export default "__VITE_ASSET__3e2ca2c1__"